import { BottomSheet } from "components/BottomSheet";
import { DatePickerNew } from "components/DatePickerNew";
import { DropdownFormProvider } from "components/DropdownFormProvider";
import { FormProvider } from "react-hook-form";
import { CreateTransportSedelLogicRetVal } from "../useCreateTransportSedelLogic";
import { SheetPrimaryButton, SheetSecondaryButton } from "./SheetActions";

type Props = {
  logic: CreateTransportSedelLogicRetVal;
  title: string;
  actionText?: string;
};

export const OperatorTransportSedelSheet = ({
  logic,
  title,
  actionText = "Spara",
}: Props) => (
  <BottomSheet
    isOpen={logic.isModalOpen}
    onClose={logic.onModalClose}
    afterClose={logic.afterModalClose}
    title={title}
  >
    <FormProvider {...logic.form}>
      <form className="space-y-6 pb-2" onSubmit={logic.onSubmit}>
        <DropdownFormProvider
          items={logic.wasteStationDropdownItems}
          label="Mottagarstation"
          name="wasteStationUuid"
          hideClearButton
        />
        <DropdownFormProvider
          items={logic.vehicleDropdownItems}
          label="Fordon"
          name="vehicleUuid"
          hideClearButton
        />
        <div className="inline-block">
          <DatePickerNew
            name="timeOfDepartureUtc"
            label={"Tid för avfärd"}
            // showTimeInput
          />
        </div>

        <div className="flex gap-x-3 border-t border-gray-75 pt-4">
          <SheetSecondaryButton onClick={logic.onModalClose} />
          <SheetPrimaryButton
            isLoading={logic.mutation.isPending}
            loadingText="Sparar..."
          >
            {actionText}
          </SheetPrimaryButton>
        </div>
      </form>
    </FormProvider>
  </BottomSheet>
);
